import React, { useState, useEffect } from 'react';

/**
 * Mobile Menu Component
 * Handles mobile menu toggle and submenu functionality
 */
const MobileMenu = () => {
	const [ isOpen, setIsOpen ] = useState( false );
	const [ activeSubmenu, setActiveSubmenu ] = useState( null );

	useEffect( () => {
		// Close menu when clicking outside
		const handleClickOutside = ( e ) => {
			const navigation = document.querySelector( '.main-navigation' );
			const menuToggle = document.querySelector( '.menu-toggle' );

			if ( isOpen && navigation && ! navigation.contains( e.target ) && ! menuToggle.contains( e.target ) ) {
				setIsOpen( false );
			}
		};

		document.addEventListener( 'click', handleClickOutside );
		return () => document.removeEventListener( 'click', handleClickOutside );
	}, [ isOpen ] );

	const toggleSubmenu = ( menuId ) => {
		setActiveSubmenu( activeSubmenu === menuId ? null : menuId );
	};

	return null; // Menu toggle is handled by native JavaScript for better WordPress integration
};

export default MobileMenu;
